export const frontmatter = {
    "draft": false,
    "title": "Sistema de tickets",
    "description": "Sistema de tickets y atención al cliente en OnnIA.",
    "sidebar_label": "Descripción general",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []